import { render, staticRenderFns } from "./termsOfUse.vue?vue&type=template&id=28ebb86a&scoped=true&"
import script from "./termsOfUse.vue?vue&type=script&lang=ts&"
export * from "./termsOfUse.vue?vue&type=script&lang=ts&"
import style0 from "./termsOfUse.vue?vue&type=style&index=0&id=28ebb86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ebb86a",
  null
  
)

export default component.exports